import React, { useState } from "react"; 
import {Helmet} from "react-helmet";
import '../index.css';
 

const F0Fview = () => {
	const ref = useState()
	return ( 
		<div>
			<Helmet>
					<meta charSet="utf-8" />
					<title>Youtubers Clan- Error</title>        
					<meta name="description" content="Youtubers Clan App help the youtubers to boost up their channel through advertisements, chat with youtubers, and build a stronger profile. Youtubers Clan App is a social app specially designed for YouTubers that provides analytics tools, trending keywords, Chat & add Campaign features to promote your channel, reels, videos, and shorts to thousands of users to boost subscribers, views, comments, watch time, and likes." />
					<meta name="keywords" content="Youtubers, YoutubersClan, Youtubers Clan, 404, Youtuber Clan App, YT Clan, Analytics Tools, Promote Channel, Trending keywords, Live Chat, Discover New Creators " />
					<meta name="author" content="Megamind Core"/>
			</Helmet>
			<div
			offset={0.2}
			speed={0.2}
			factor={1}
			style={{ 
				position: 'center'
			}}
			>	
						
			<br/>  <br/>  <br  />  <br/>  <br/>  <br/>  <br  />  <br/> <br/>  <br/>  <br  />  <br/> 
			<div className="heading">404 Error</div> 
			<div className="subHeading">Page Not Found</div>  
			<br/>  <br/>  <br  />  <br/>  <br/>  <br/>  <br  />  <br/> <br/>  <br/>  <br  />  <br/> 
			</div>
		</div>
	)
}

const F0F = () => {
return (
	F0Fview()
);
};

export default F0F;
